import * as React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { LinkableCell, TableCell } from '../table-pieces.component';
import { ValueWithCopyButton } from '../../value-with-copy-button/value-with-copy-button.component';

export type IdCellProps = {
  itemId?: string;
  linkTo?: string;
};

export const IdCell: React.FC<IdCellProps> = ({ itemId, linkTo }) => {
  const { formatMessage } = useIntl();
  if (itemId) {
    return (
      <TableCell>
        <ValueWithCopyButton
          value={itemId}
          buttonLabel={formatMessage({ id: 'COPY_ENTITY_ID' })}
        />
      </TableCell>
    );
  }
  return <LinkableCell linkTo={linkTo} />;
};
